import React from 'react'
import { Link } from '@inertiajs/inertia-react'
import Layout from '../../Shared/Layout/LayoutAdmin'
import LayoutSiaLearner from '../../Shared/Layout/LayoutSiaLearner'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import { SIA_NAVY } from '../../constants/siaTheme'

const MODULE_PATHS = {
    cobranza: 'admin/cobranza',
    secom: 'admin/secom',
    cotizadores: {
        learner: 'admin/sia/capacitacion/modulos/cotizadores',
        manage: 'admin/sia/manage/modulos/cotizadores',
    },
}

const ModulePlaceholder = ({ title, moduleKey, variant }) => {
    let path
    if (moduleKey === 'cotizadores') {
        path = variant === 'manage' ? MODULE_PATHS.cotizadores.manage : MODULE_PATHS.cotizadores.learner
    } else {
        path = MODULE_PATHS[moduleKey] || `admin/${moduleKey}`
    }

    const showBreadcrumbs = variant === 'manage' || variant === 'admin'

    return (
        <>
            {showBreadcrumbs && (
                <div className="mb-5 mt-5">
                    <Breadcrumbs currentPath={path} />
                </div>
            )}

            <div
                className="rounded-2 mb-8 py-5 px-4 text-center text-white text-uppercase fw-bold fs-3"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.02em' }}
            >
                {title}
            </div>

            <div className="card card-flush shadow-sm">
                <div className="card-body py-15 px-8 text-center">
                    <p className="text-gray-700 fs-5 mb-6">
                        Este módulo estará disponible próximamente. Aquí se mostrará el contenido formativo correspondiente.
                    </p>
                    {variant === 'learner' ? (
                        <Link href={route('sia.index')} className="btn btn-primary">
                            Volver al inicio SIA
                        </Link>
                    ) : variant === 'manage' ? (
                        <Link href={route('sia.manage.index')} className="btn btn-primary">
                            Volver al panel SIA
                        </Link>
                    ) : (
                        <Link href={route('admin')} className="btn btn-primary">
                            Volver al inicio
                        </Link>
                    )}
                </div>
            </div>
        </>
    )
}

ModulePlaceholder.layout = (page) => {
    const title = page.props.title || 'SIA'
    if (page.props.variant === 'learner') {
        return <LayoutSiaLearner title={`${title} | SIA`}>{page}</LayoutSiaLearner>
    }
    return <Layout title={title}>{page}</Layout>
}

export default ModulePlaceholder
